import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const SearchIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 0a7 7 0 1 0 4.192 12.606l3.1 3.101a1 1 0 0 0 1.415-1.414l-3.1-3.1A7 7 0 0 0 7 0ZM2 7a5 5 0 1 1 10 0A5 5 0 0 1 2 7Z", fill: "currentColor" })));
});
SearchIcon.displayName = 'SearchIcon';
export default SearchIcon;
